export const CLINICIANS = [
  {
    slug: "venkata-bandaru",
    name: "Dr Venkata Bandaru",
    role: "Clinical Director · TRT Specialist",
    regulator: "General Medical Council (GMC)",
    regNo: "6141015",
    regUrl: "https://www.gmc-uk.org/registration-and-licensing/the-medical-register",
    image: "/team/bandaru.jpg",
    summary:
      "Dr Venkata Sharath Bandaru is a dedicated and compassionate doctor with a strong background in both NHS and private healthcare. He takes a holistic approach, building long-term therapeutic relationships while delivering evidence-based treatment tailored to the individual.",
    experience:
      "With over 15 years in medicine, Dr Bandaru has held senior roles in NHS general practice and accident and emergency departments, and serves as Clinical Director at Ready Health Private Medical Clinic in Standish. His work spans acute and chronic disease management, health screening and private clinical consultation across primary and secondary care.",
    specialisms: [
      "Men's health and preventative screening",
      "Chronic disease management (diabetes, hypertension, asthma)",
      "Lifestyle and weight management medicine",
      "Mental health and wellbeing",
    ],
    education:
      "Medical degree completed in India, followed by postgraduate training in the United Kingdom. Fully registered and licensed with the GMC, with annual appraisal and revalidation.",
  },
  {
    slug: "shamir-patel",
    name: "Mr Shamir Patel",
    role: "CQC Registered Manager · Clinical Pharmacist & Independent Prescriber",
    regulator: "General Pharmaceutical Council (GPhC)",
    regNo: "2049338",
    regUrl: "https://www.pharmacyregulation.org/registers",
    image: "/team/patel.jpg",
    summary:
      "Shamir Patel is an experienced Independent Clinical Pharmacist known for high-quality, patient-centred care in NHS and private settings, committed to safe, evidence-based prescribing and clinical governance.",
    experience:
      "Over 25 years in the pharmacy profession, including senior roles across community pharmacy and primary care networks. He leads prescribing services and advanced clinical consultations at Ready Health, and has served as a Designated Prescribing Practitioner mentoring independent-prescribing trainees.",
    specialisms: [
      "Clinical governance and CQC registered management",
      "Cardiovascular risk management",
      "Long-term condition optimisation",
      "Weight management, including GLP-1 prescribing",
    ],
    education:
      "Master of Pharmacy (1995); postgraduate Independent Prescriber qualification; advanced clinical training through the Primary Care Pharmacy Education Pathway. Member of the Royal Pharmaceutical Society and the Primary Care Pharmacy Association. SCOPE certified (World Obesity Federation).",
  },
  {
    slug: "hamza-khairkhwah",
    name: "Mr Hamza Khairkhwah",
    role: "Clinical Independent Prescribing Pharmacist · Male Hormone Health",
    regulator: "General Pharmaceutical Council (GPhC)",
    regNo: "2228294",
    regUrl: "https://www.pharmacyregulation.org/registers",
    image: "/team/khairkhwah.jpg",
    summary:
      "Hamza Khairkhwah is a Clinical Independent Prescribing Pharmacist specialising in male hormone health and testosterone optimisation, medical weight management and ADHD. He is known for a structured, methodical approach, taking each treatment plan from first consultation through to stable, well-monitored maintenance.",
    experience:
      "Hamza has practised across private clinical services and primary care, with experience in cardiovascular risk assessment, structured medication review and monitoring high-risk medicines against blood results. He has authored prescribing protocols and risk assessments and led clinical audit within private prescribing services, with a strong emphasis on shared decision-making.",
    specialisms: [
      "Male hormone health and testosterone optimisation",
      "Cardiovascular risk assessment and management",
      "Medical weight management, including GLP-1 prescribing",
      "Monitoring high-risk medicines against blood results",
    ],
    education:
      "First Class Master of Pharmacy (MPharm), University of Bradford, 2021; Independent Prescriber (University of Bradford). SCOPE accredited by the World Obesity Federation (2024); NCSCT Certified Smoking Cessation Practitioner (2024).",
  },
];
